import { ArrowRight, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';

const publicLinks = [
  ['/school-email-assistant', 'School email'],
  ['/family-calendar-app', 'Family calendar'],
  ['/shared-family-task-manager', 'Shared tasks'],
  ['/faq', 'FAQ'],
];

export function PublicFooter() {
  return (
    <footer className="border-t border-slate-200 bg-slate-950 text-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-12 sm:px-8 md:grid-cols-[1fr_auto_auto]">
        <div className="max-w-md">
          <Link to="/" className="text-xl font-black text-white no-underline">Little Adda</Link>
          <p className="mt-3 text-sm leading-7 text-slate-300">
            School-email intelligence that keeps parents in control of every family action.
          </p>
        </div>
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-teal-300">Explore</p>
          <div className="mt-4 grid gap-3 text-sm font-semibold text-slate-300">
            {publicLinks.map(([to, label]) => <Link key={to} to={to} className="hover:text-white">{label}</Link>)}
          </div>
        </div>
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-teal-300">Company</p>
          <div className="mt-4 grid gap-3 text-sm font-semibold text-slate-300">
            <Link to="/about" className="hover:text-white">About</Link>
            <Link to="/privacy-and-security" className="hover:text-white">Privacy &amp; security</Link>
            <Link to="/login" className="hover:text-white">Sign in</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 px-5 py-5 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} Little Adda. A parent-focused family organization product.
      </div>
    </footer>
  );
}

function PublicSiteLayout({ children, eyebrow, title, lede }) {
  return (
    <div className="min-h-screen bg-[#f7faf7] text-slate-950">
      <header className="border-b border-slate-200 bg-white/95">
        <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-4 sm:px-8" aria-label="Public navigation">
          <Link to="/" className="flex items-center gap-3 text-slate-950 no-underline">
            <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-teal-700 text-sm font-black text-white">LA</span>
            <span className="text-lg font-black">Little Adda</span>
          </Link>
          <div className="hidden items-center gap-5 lg:flex">
            {publicLinks.map(([to, label]) => <Link key={to} to={to} className="text-sm font-bold text-slate-600 hover:text-teal-800">{label}</Link>)}
          </div>
          <div className="flex items-center gap-2">
            <Menu className="h-5 w-5 text-slate-500 lg:hidden" aria-hidden="true" />
            <Link to="/login" className="hidden rounded-xl px-3 py-2 text-sm font-bold text-slate-700 sm:inline-block">Sign in</Link>
            <Link to="/signup" className="inline-flex items-center gap-2 rounded-xl bg-teal-700 px-4 py-2 text-sm font-black text-white shadow-subtle hover:bg-teal-800">
              Get started <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
          </div>
        </nav>
      </header>

      <main>
        <section className="border-b border-teal-100 bg-[radial-gradient(circle_at_top_right,rgba(45,212,191,0.18),transparent_35%),linear-gradient(180deg,#ffffff,#f0fdfa)]">
          <div className="mx-auto max-w-5xl px-5 py-16 sm:px-8 sm:py-24">
            <p className="text-xs font-black uppercase tracking-[0.18em] text-teal-700">{eyebrow}</p>
            <h1 className="mt-5 max-w-[16ch] text-4xl font-black leading-[1.06] tracking-tight sm:text-6xl">{title}</h1>
            <p className="mt-6 max-w-3xl text-lg leading-8 text-slate-600 sm:text-xl">{lede}</p>
          </div>
        </section>
        {children}
      </main>

      <PublicFooter />
    </div>
  );
}

export default PublicSiteLayout;
